import {gql} from "@apollo/client";
import {useEffect} from "react";
import {DeepPartial, UnpackNestedValue, UseFormReturn} from "react-hook-form";
import {useLazyQuery$} from "../../../../graphqlsupport";
import {ClientReturnsTransferRequestInput} from "./ClientTransferReturnRequestFormAuthModal";


export type  ClientReturnsTransferData = {
    guid: string;
    authorizationGuid: string;
    isDraft: boolean;
} & ClientReturnsTransferRequestInput;

const AUTHORIZATION_LATEST_OFFERED_HOURS = gql`
query clientReturnsTransferRequestByAuth($authorizationGuid: UUID) {
    clientReturnsTransferRequestByAuth(authorizationGuid: $authorizationGuid) {
        clientServicesReceived
        requestInitiator
        familyNotifiedOfTransferNeed
        describeAttemptsMadeToResolveIssue
        dateOfLastService
        dateOfLastFullScheduleOffer
        serviceProvidedDuringTransfer
        clientReturnDate
        serviceType
        caregiverMidLevelHoursMin
        caregiverMidLevelHoursMax
        caregiverHighLevelHoursMin
        caregiverHighLevelHoursMax
        practitionerParaprofessionalHoursMin
        practitionerParaprofessionalHoursMax
        practitionerMidLevelHoursMin
        practitionerMidLevelHoursMax
        practitionerHighLevelHoursMin
        practitionerHighLevelHoursMax
        practitionerGroupCareHoursMin
        practitionerGroupCareHoursMax
        offeredParaprofessionalHours
        offeredMidLevelHours
        offeredHighLevelHours
        offeredGroupCareHours
        clinicalRecommendationChanging
        clinicalRecommendationChange
        reasonForRequest
        assessmentAppointmentOfferedDate
        wasFsoOffered
        rationale
        paraprofessionalLocation
        midLevelLocation
        highLevelLocation
        groupCareLocation
        assessmentLocation
        canContinueProvidingServices
        isDraft
    }
}
`;

function useLatestClientReturnsTransferInput$(authorizationGuid: string) {
    const {execute, data, isRunning$, error} = useLazyQuery$<{
        authorizationGuid: string
    }, {
        clientReturnsTransferRequestByAuth: ClientReturnsTransferData
    }>(AUTHORIZATION_LATEST_OFFERED_HOURS, {
        authorizationGuid,
    });

    return {
        execute,
        data,
        isRunning$,
        error
    };
}


export function useLatestClientReturnsTransferInput(showModal: boolean, methods: UseFormReturn<ClientReturnsTransferRequestInput>, authorizationGuid: string) {
    const {execute, data, isRunning$, error,} = useLatestClientReturnsTransferInput$(authorizationGuid);
    useEffect(() => {
        if (showModal && authorizationGuid != null) {
            execute({
                authorizationGuid,
            }).catch((e) => {
                console.error("Failed to get latest client returns transfer by: ", e)
            });
        }
    }, [authorizationGuid, showModal, execute]);
    useEffect(() => {
        if (data?.clientReturnsTransferRequestByAuth != null) {
            if (data.clientReturnsTransferRequestByAuth.isDraft === true) {
                methods.reset({
                    ...methods.getValues(),

                    ...(data.clientReturnsTransferRequestByAuth as UnpackNestedValue<DeepPartial<ClientReturnsTransferRequestInput>>),
                });
            } else {
                methods.reset();
            }
        }
    }, [data, methods]);
    return {
        isRunning$,
        error,
    };
}

